import React from 'react';
import styled from 'styled-components';
import T from 'i18n-react';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

type Props = {
  active?: boolean;
  participationRequestAcceptable?: boolean;
  showRequestBadge?: boolean;
};

/**
 * サムネイル直下に表示するステータスタグ。
 * TagContainer で高さを固定することでタグ種別によらず下の要素位置が安定する。
 */
const PlanStatusTag = ({
  active,
  participationRequestAcceptable,
  showRequestBadge,
}: Props) => {
  return (
    <TagContainer>
      {showRequestBadge && participationRequestAcceptable ? (
        <RequestTag>
          <CalendarMonthOutlinedIcon sx={{ width: 20, height: 20 }} />
          <TagText>{T.translate('plan.participationRequestBadge')}</TagText>
        </RequestTag>
      ) : active ? (
        <AcceptingTag>
          <TagText>{T.translate('plan.acceptingTag')}</TagText>
        </AcceptingTag>
      ) : null}
    </TagContainer>
  );
};

export default PlanStatusTag;

// タグ種別で高さが変わると下の要素位置がズレるため、高さを固定する
const TagContainer = styled.div`
  height: 26px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;

const baseTag = `
  display: inline-flex;
  align-items: center;
  gap: 2px;
  border-radius: 4px;
`;

// RequestTag と box model を揃えるため transparent border を付与
const AcceptingTag = styled.div`
  ${baseTag}
  padding: 4px 8px;
  border: 1px solid transparent;
  background-color: #ff6e2e;
  color: #ffffff;
`;

const RequestTag = styled.div`
  ${baseTag}
  padding: 2px 4px;
  background-color: #ffffff;
  color: #ff6e2e;
  border: 1px solid #ff6e2e;
`;

const TagText = styled.span`
  /* Bold/text-xs */
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;
